(function () {
  var toggle = document.querySelector('[data-sova-menu-toggle]');
  var panel = document.querySelector('[data-sova-mobilenav]');
  if (!toggle || !panel) return;

  toggle.addEventListener('click', function () {
    var isOpen = !panel.hidden;
    panel.hidden = isOpen;
    toggle.setAttribute('aria-expanded', String(!isOpen));
  });
})();
